import { useState } from "react";
import Input from "../components/Input";
import SeletorQtdMes from "./SeletorQtdMes";
import calculadora from "../img/calculator-finance.png";
import Button from "../components/Button";
import style from "../style/juntar.module.css";
import MinInput from "./MinInput";
import Alert from "../components/Alert";
import {
  juntarMoney,
  conveterParaMonetario,
} from "../function/funcionalidades";
import Saldo from "./Saldo";

export default function Juntar() {
  const [valor, setValor] = useState("");
  const [qtdMes, setQtdMes] = useState("");
  const [valorAcumulado, setValorAcumulado] = useState("");
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [registrado, setRegistrado] = useState(false);

  const verificar = () => {
    let result;
    if (valor === "" || qtdMes === "") {
      setModal(true);
      setTitle("Erro");
      setMensagem("Por favor,os campos vazios!");
      return;
    } else {
      result = juntarMoney(valor, qtdMes);
      setRegistrado(true);
      setValorAcumulado(conveterParaMonetario(result));
    }

    console.log(result);
  };

  return (
    <div>
      <Saldo />
      <section className={style.content}>
        <div className={style.positionContent}>
          <div className={style.postionField}>
            <div className={style.campo}>
              <label htmlFor="valor" className={style.label}>
                Quanto quer Juntar ?
              </label>
              <MinInput
                id="valor"
                placeholder="valor"
                valor={valor}
                mask="currency"
                inputMask={setValor}
                width="478"
              />
            </div>
            <div className={style.campo}>
              <label htmlFor="qtdMes" className={style.label}>
                Em quantos anos ?
              </label>
              <SeletorQtdMes id="qtdMes" mes={qtdMes} setMes={setQtdMes} />
            </div>
          </div>

          {modal && (
            <Alert
              isOpen={modal}
              setOpen={() => setModal(false)}
              mensagem={mensagem}
              title={title}
            />
          )}
          <div className={style.positionCalc}>
            <img src={calculadora} />
            <div className={style.positionInformationCalcu}>
              {!registrado ? (
                <p className={style.information}>Nenhuma informação inserida</p>
              ) : (
                <p className={style.information}>
                  Você terá guardado o total de{" "}
                  <strong className={style.value}>{valorAcumulado}</strong>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className={style.positionButton}>
          <Button title="Verificar" click={verificar} />
        </div>
      </section>
    </div>
  );
}
